import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

// We can follow the exemple of this file /src/modules/admin/archiving/containers/formHandlers/atmTransactionInquiryDetails/ATMTransactionInquiryDetailsFormMeta.ts

export interface IConsultPrepaidTransactionDetailsFormMeta {
  agency: FormInputMeta,
  microfilmReferenceNumber: FormInputMeta,
  client: FormInputMeta,
  cardholder: FormInputMeta,
  PAN: FormInputMeta,
  HPXAccount: FormInputMeta,
  bankAccount: FormInputMeta,
  accountCurrency: FormInputMeta,
  paymentMode: FormInputMeta,
  reloadFees: FormInputMeta,
  rechargeDate: FormInputMeta,
  rechargeAmount: FormInputMeta,
  rechargeFees: FormInputMeta,
  //
  schema: any;
}

const ConsultPrepaidTransactionDetailsFormMeta = {} as IConsultPrepaidTransactionDetailsFormMeta;

ConsultPrepaidTransactionDetailsFormMeta.agency = {
  name: 'agency',
  type: 'text',
  label: 'Agence',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.microfilmReferenceNumber = {
  name: 'microfilmReferenceNumber',
  type: 'text',
  label: 'N° Reference microfilm',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.client = {
  name: 'client',
  type: 'text',
  label: 'Client',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.cardholder = {
  name: 'cardholder',
  type: 'text',
  label: 'Porteur',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.PAN = {
  name: 'PAN',
  type: 'text',
  label: 'PAN',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.HPXAccount = {
  name: 'HPXAccount',
  type: 'text',
  label: 'Compte HPX',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.bankAccount = {
  name: 'bankAccount',
  type: 'text',
  label: 'Compte bancaire',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.accountCurrency = {
  name: 'accountCurrency',
  type: 'text',
  label: 'Devise',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.paymentMode = {
  name: 'paymentMode',
  type: 'text',
  label: 'Mode de paiement',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.reloadFees = {
  name: 'reloadFees',
  type: 'text',
  label: 'Frais de relance',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultPrepaidTransactionDetailsFormMeta.rechargeDate = {
  name: 'rechargeDate',
  type: 'text',
  label: 'Date de recharge',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.rechargeAmount = {
  name: 'rechargeAmount',
  type: 'text',
  label: 'Montant de la recharge',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.rechargeFees = {
  name: 'rechargeFees',
  type: 'text',
  label: 'Frais de recharge',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultPrepaidTransactionDetailsFormMeta.schema = yup.object().shape(getValidationSchema(ConsultPrepaidTransactionDetailsFormMeta));

export default ConsultPrepaidTransactionDetailsFormMeta;